import utils from "Sources/utils/utils";
//import NavUtils from "Sources/utils/navigation-utils";
const log = require("Sources/utils/logger")();
import HtmlTemplate from "Views/partials/sessions/session-image-button.html";

import "Styles/components/mission-label.scss";

class SessionImageButton
{
  constructor(options)
  {
    this.$container = $(options.container);
    this.hasRendered = false;
    this.imageButton = options.imageButton;
    this.imageFolder = options.imageFolder;
    this.onImageSelected = options.onImageSelected;
    this.selected = false;
  }

  get imageButton()
  {
    return this._imageButton;
  }

  set imageButton(imageButton)
  {
    this._imageButton = imageButton;
    this.updateSessionImageButton();
  }

  static setUpSessionImageButton(options)
  {
    let instance = new SessionImageButton(options);
    instance.render();
    instance.setUpEventListeners();
    return instance;
  }

  setUpEventListeners()
  {
    let that = this;
    this.$element.on("click", function(e)
    {
      that.onImageSelected(that.imageButton.key, that.imageButton.url);
    });
  }

  render()
  {
    this.hasRendered = false;
    this.$element = $(HtmlTemplate);
    this.$container.append(this.$element);

    this.updateSessionImageButton();
    this.hasRendered = true;
  }

  show()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.show();
    }
  }

  hide()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.hide();
    }
  }

  destroy()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.remove();
    }
  }

  updateSessionImageButton() {
    if (utils.isNotNull(this.$element) && this.$element.length) {
      if (utils.isNotNull(this.imageButton) && utils.isNotNull(this.imageButton.key)) {
        let imageUrl = this.imageButton.url;
        this.$element.find("img").attr("src", imageUrl);
      }
    }
  }

}

export default SessionImageButton;



// WEBPACK FOOTER //
// ./app/js/components/session-image-button.js